module.exports = __webpack_public_path__ + "img/img4.d6b3ad6c.png";